import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartProps } from "./Chart.interface";

const Chart = ({ data }: ChartProps) => {
  return (
    <ResponsiveContainer width="100%" height={200}>
      <LineChart
        data={data}
        margin={{ top: 5, right: 20, left: 20, bottom: 5 }}
      >
        <CartesianGrid horizontal={false} />
        <Tooltip formatter={(value) => [`${value} Кб/сек`, "Битрейт"]} />
        <XAxis
          dataKey="name"
          tick={{ fontSize: 12 }}
          tickMargin={10}
        />
        <YAxis
          tick={{ fontSize: 12 }}
          width={40}
        />
        <Line
          type="monotone"
          dataKey="bitrate"
          stroke="#8884d8"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default Chart;
